import { render, staticRenderFns } from "./guzergahBilgisi.vue?vue&type=template&id=7522e27f&"
import script from "./guzergahBilgisi.vue?vue&type=script&lang=js&"
export * from "./guzergahBilgisi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports